import { CommonModule } from '@angular/common'
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core'
import { Router, RouterModule } from '@angular/router'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { DdcLoggerService } from 'src/app/service/log/ddc-logger.service'
import { UserService } from 'src/app/service/user-info/user.service'
import { LibraryChips } from '../../enums/enums'
import { DdcButtonNOneComponent } from '../ddc-button-n-one/ddc-button-n-one.component'
import { DdcTextGradientComponent } from '../ddc-text-gradient/ddc-text-gradient.component'

interface DummyAgent {
  name: string
  status: 'online' | 'offline' | 'busy'
  icon: string
}

@Component({
  selector: 'ddc-dashboard-card',
  templateUrl: './ddc-dashboard-card.component.html',
  styleUrl: './ddc-dashboard-card.component.scss',
  encapsulation: ViewEncapsulation.Emulated,
  imports: [
    AngularMaterialsModules,
    CommonModule,
    RouterModule,
    DdcTextGradientComponent,
    DdcButtonNOneComponent,
  ],
})
export class DdcDashboardCardComponent implements OnInit {
  _info: any
  @Input('isLoading') _isLoading: boolean
  _dummyAgents: DummyAgent[] = []

  constructor(
    private logger: DdcLoggerService,
    private router: Router,
    public user_service: UserService,
  ) {}

  ngOnInit(): void {
    this.getDashboardInfo()
    this.loadDummyAgents()
  }

  loadDummyAgents(): void {
    this._dummyAgents = [
      { name: 'Language Tutor', status: 'online', icon: 'school' },
      { name: 'Translation Assistant', status: 'busy', icon: 'translate' },
      { name: 'Vocabulary Builder', status: 'offline', icon: 'book' },
    ]
  }

  getDashboardInfo(): void {
    this.logger.info('DdcDashboardCardComponent: getDashboardInfo()')
    this.user_service.get_user_profile().subscribe((res: any) => {
      if (res) {
        setTimeout(() => {
          this._info = res
        }, 500) // two seconds
      }
    })
  }

  followersClicked(): void {
    this.router.navigate(['/network', LibraryChips.FOLLOWERS])
  }

  followingClicked(): void {
    this.router.navigate(['/network', LibraryChips.FOLLOWING])
  }

  catsClicked(): void {
    this.router.navigate(['/library', LibraryChips.CATEGORIES])
  }

  tagsClicked(): void {
    this.router.navigate(['/library', LibraryChips.TAGS])
  }

  dashboardElementClicked(element: string): void {
    this.logger.info('DdcDashboardCardComponent: dashboardElementClicked() | element:', element)

    if (element === 'words') {
      this.router.navigate(['/library', LibraryChips.WORDS])
    } else if (element === 'pairs') {
      this.router.navigate(['/library', LibraryChips.PAIRS])
    } else if (element === 'dics') {
      this.router.navigate(['/library', LibraryChips.DICTIONARIES])
    } else if (element === 'cats') {
      this.router.navigate(['/library', LibraryChips.CATEGORIES])
    } else if (element === 'tags') {
      this.router.navigate(['/library', LibraryChips.TAGS])
    } else if (element === 'followers') {
      this.router.navigate(['/network', LibraryChips.FOLLOWERS])
    } else if (element === 'following') {
      this.router.navigate(['/network', LibraryChips.FOLLOWING])
    }
  }
}
